@if (tableList) {
  <section>
    @for (table of tableList; track $index) {
      <app-table-card [table]="table"></app-table-card>
    }
  </section>
}
@if (linkList) {
  <section>
    @for (link of linkList; track $index) {
      <app-link-card [link]="link" [isEnglish]="isEnglish"></app-link-card>
    }
  </section>
}
